import * as React from 'react';
import { css, Panel, PanelType} from 'office-ui-fabric-react';
import { IFieldMapping, MappingType, ExternalFieldInfo, MapConfig } from '../../store/integration/common';
import { SourceType, SourceTypeMap } from '../../store/ExternalEpmConnectStore';
import { EntityType } from '../../entities/common';
import MappingPanelControl from './MappingPanelControl/MappingPanelControl';

type OwnProps = {
    connector: SourceType;
    entityType: EntityType;
    externalFields: ExternalFieldInfo[];
    typesMap: { [externalFieldMap: string]: MapConfig };
    mapping: IFieldMapping[] | null;
    updateMapping: (mapping: IFieldMapping[]) => void;
    mappingTypes: MappingType[];
    showTransformationScript?: boolean;
    onDismiss: () => void;
    isLoading: boolean;
    error: string | null;
    disabled?: boolean;
    typeName?: string;
    onRenderHeader?: () => JSX.Element;
    onGetExternalFieldOptions?: (field: ExternalFieldInfo) => Promise<string[] | number[] | null>;
    isDirty?: boolean;
    className?: string;
}

type StateProps = {
}

const panelWidth: string = "600px";

const defaultHeaderRenderer = (connector: SourceType, typeName?: string) => (): JSX.Element => {
    return <div className="ms-Panel-header">
        <p className="ms-Panel-headerText">Configure {typeName ? `${typeName} ` : ''}import mapping</p>
        <div className='ms-Panel-secondaryText'>Set up fields and directions for the data exchange in {SourceTypeMap[connector]}.</div>
    </div>;
}

const MappingPanel = (props: React.PropsWithChildren<OwnProps & StateProps>) => {

    const { typeName, connector } = props;
    const onRenderHeader = React.useCallback(() => props.onRenderHeader ?? defaultHeaderRenderer(connector, typeName), [connector, typeName])

    return <Panel isLightDismiss
            type={PanelType.custom}
            customWidth={panelWidth}
            className={css("mapping-panel", props.className)}
            isOpen
            onRenderHeader={onRenderHeader()}
            onDismiss={props.onDismiss}>
        <MappingPanelControl {...props}
            onRenderHeader={undefined}
            panelWidth={panelWidth}
        />
        </Panel>
}

export default MappingPanel;